import { assertValidVersion } from "@tsparticles/engine";
import { LifeUpdater } from "./LifeUpdater.js";
export async function loadLifeUpdater(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addParticleUpdater("life", async (container) => {
        return Promise.resolve(new LifeUpdater(container));
    }, refresh);
}
